<template>
  <VerifyIdentityMfa
    :displayCheck="displayCheck"
    :displayCodeResend="displayCodeResend"
    :displayCodeSent="displayCodeSent"
    :displayErrorPage="displayErrorPage"
    :displayExplanation="displayExplanation"
    :displayMfaCodeError="displayMfaCodeError"
    :displaySuccessPage="displaySuccessPage"
    :helperText="
      coalescedSupportText('common.contact_health_plan_csr.contact_info_change')
    "
    :mfaPreference="mfaType"
    @cancel="$emit('cancel')"
    @requestMfaCode="onRequestElevatedRoleMfaCode"
    @verifyMfaCode="onVerifyElevatedRoleMfaCode"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  TOO_MANY_CHECK_ATTEMPTS,
  TOO_MANY_SEND_ATTEMPTS,
} from '@platform-shared/verify-constants'
import { MFA_TYPES } from '@platform-shared/constants'
import VerifyIdentityMfa from '@components/common/mfa/VerifyIdentityMfa'
import supportMixin from '@components/mixins/support'

export default {
  components: { VerifyIdentityMfa },
  mixins: [supportMixin],
  data: () => ({
    displayCodeResend: false,
    displayErrorPage: false,
    displayMfaCodeError: false,
    displaySuccessPage: false,
  }),
  computed: {
    ...mapGetters('member', ['availableMfaModalities', 'mfaType']),
    displayCheck() {
      return this.mfaType === MFA_TYPES.EMAIL
        ? this.$t('mfa.check_email')
        : this.$t('mfa.check_phone')
    },
    displayCodeSent() {
      const result = this.availableMfaModalities.find(
        (x) => x.type === this.mfaType
      )?.value
      return result ? this.$t('mfa.code_sent', [result]) : ''
    },
    displayExplanation() {
      return this.mfaType === MFA_TYPES.EMAIL
        ? this.$t('mfa.explanation_email')
        : this.$t('mfa.explanation_phone')
    },
  },
  methods: {
    ...mapActions('member', [
      'requestElevatedRoleMfaCode',
      'verifyElevatedRoleMfaCode',
    ]),
    onRequestElevatedRoleMfaCode() {
      this.requestElevatedRoleMfaCode()
        .then(() => {
          this.displayCodeResend = true
          setTimeout(() => {
            this.displayCodeResend = false
          }, 5000)
        })
        .catch((e) => {
          if (e.message === TOO_MANY_SEND_ATTEMPTS) {
            this.displayErrorPage = true
          }
        })
    },
    onVerifyElevatedRoleMfaCode(totp) {
      this.mfaCodeError = false

      this.verifyElevatedRoleMfaCode(totp)
        .then(() => {
          this.displaySuccessPage = true
          setTimeout(() => {
            this.$emit('continue')
          }, 3000)
        })
        .catch((e) => {
          if (e.message === TOO_MANY_CHECK_ATTEMPTS) {
            this.displayErrorPage = true
          } else {
            this.displayMfaCodeError = true
          }
        })
    },
  },
}
</script>
